import script from "./PersonalCardSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCardSingle.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCardSingle.vue?vue&type=style&index=0&id=9d288e9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d288e9c"]])

export default __exports__